import { useEffect, useState } from 'react';
import useUpdateFavoriteMeal from '../../hooks/data/meals/useUpdateFavoriteMeal';
import MealEditorLayout from './MealEditorLayout';
import ErrorMessage from '../ui/ErrorMessage';
import DiaryModal from '../diary/DiaryModal';
import useModalController from '../../hooks/modal/useModalController';

const FavoriteMealEditorPage = ({ meal }) => {
    const { updateFavoriteMeal, isUpdating, isError, error, isSuccess, reset } = useUpdateFavoriteMeal();

    const controller = useModalController();

    const [editableMeal] = useState(() => ({
        ...meal,
        items: meal.items.map((item) => ({
            ...item,
            base: {
                kcal: item.kcal,
                protein: item.protein,
                fat: item.fat,
                carbs: item.carbs,
                amount: item.amount,
                unit: item.unit
            }
        }))
    }));

    const handleSave = async (updatedMeal) => {
        await updateFavoriteMeal({
            id: updatedMeal.id,
            name: updatedMeal.name,
            items: updatedMeal.items.map((item) => ({
                id: item.id,
                meal_id: updatedMeal.id,
                amount: item.amount,
                unit: item.unit?.id ?? item.base.unit.id,
                name: item.name,
                food_item_id: item.food_item_id ?? null,
                is_new: item.is_new ?? false
            }))
        });
    };

    useEffect(() => {
        if (!isSuccess) return;

        const timer = setTimeout(() => {
            reset();
        }, 1500);

        return () => clearTimeout(timer);
    }, [isSuccess]);

    if (isError) return <ErrorMessage message={error?.message || 'Ett fel uppstod vid uppdatering.'} />;

    return (
        <div className="favorite-meal-edit-page">
            <MealEditorLayout
                meal={editableMeal}
                openDiaryModal={controller.open}
                onSave={handleSave}
                isSaving={isUpdating}
                isSuccess={isSuccess}
                isError={isError}
                error={error}
            />

            {controller.isOpen && (
                <DiaryModal controller={controller} meals={{}} exerciseSession={null} currentDay={null} />
            )}
        </div>
    );
};

export default FavoriteMealEditorPage;
